
import React from 'react';
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { GalleryImage } from './GalleryExtension';
import { 
  Carousel, 
  CarouselContent, 
  CarouselItem, 
  CarouselNext, 
  CarouselPrevious 
} from '@/components/ui/carousel';

const GalleryNodeView: React.FC<NodeViewProps> = ({ node }) => {
  const { images, layout, title } = node.attrs;
  
  if (!images || images.length === 0) {
    return (
      <NodeViewWrapper className="article-gallery article-gallery-empty" data-layout={layout}>
        <div className="gallery-placeholder">Gallery (no images)</div>
      </NodeViewWrapper>
    );
  }

  // For editor view rendering
  return (
    <NodeViewWrapper className={`article-gallery article-gallery-${layout}`} data-layout={layout}>
      {title && <h4 className="gallery-title">{title}</h4>}
      
      {layout === 'slider' ? (
        <div className="gallery-slider-wrapper">
          <Carousel>
            <CarouselContent>
              {images.map((image: GalleryImage, index: number) => (
                <CarouselItem key={index}>
                  <figure className="gallery-item">
                    {image.url ? (
                      <img 
                        src={image.url} 
                        alt={image.altText || ''} 
                        loading="lazy"
                      />
                    ) : (
                      <div className="gallery-image-error">Invalid image source</div>
                    )}
                    {image.caption && <figcaption>{image.caption}</figcaption>}
                  </figure>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      ) : (
        <div className={`gallery-${layout}`}>
          {images.map((image: GalleryImage, index: number) => (
            <figure key={index} className="gallery-item">
              {image.url ? (
                <img 
                  src={image.url} 
                  alt={image.altText || ''} 
                  loading="lazy"
                />
              ) : (
                <div className="gallery-image-error">Invalid image source</div>
              )}
              {image.caption && <figcaption>{image.caption}</figcaption>}
            </figure>
          ))}
        </div>
      )}
    </NodeViewWrapper>
  );
};

export default GalleryNodeView;
